document.addEventListener("alpine:init", () => {
    Alpine.store("share", {
        open: false,
    });
    const shareButton = document.querySelector(".share-button");
    const shareInput = document.querySelector(".share-input");

    if (shareButton && shareInput) {
        shareButton.addEventListener("click", (event) => {
            event.preventDefault();

            const resultat = shareInput.value;
            if (resultat) {
                navigator.clipboard.writeText(resultat);
            }
        });
    }
});
